import React, { Component } from "react";
import "./Main.css";
import { OverdueInvoiceDashboard } from "./OverdueInvoiceDashboard";
import { OutstandingInvoicesDashboard } from "./OutstandingInvoicesDashboard";

export class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			BuildingData: null,
			CurrentBuilding: null,
		};
	}
	async getData() {
		if (this.props.building) {
			const data = await fetch("Building/GetBuildingData", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				cache: "no-cache",
				body: JSON.stringify({ buildingsId: this.props.building }),
			});
			var res = await data.json();
			this.setState({ BuildingData: res });
		}
	}

	render() {
		return (
			<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1 }}>
				<OverdueInvoiceDashboard></OverdueInvoiceDashboard>
				<OutstandingInvoicesDashboard></OutstandingInvoicesDashboard>
				{/* <InvoicedAmountDashboard></InvoicedAmountDashboard> */}
			</div>
		);
	}
}
